import { useState } from 'react';

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="px-4 sm:px-8 lg:px-12">
        <div className="flex justify-between items-center h-20">
          <a href="/" className="cursor-pointer">
            <img
              src="https://static.readdy.ai/image/2d70788572f3bf6ab3fc4009e4756eb5/7f9ed3602ae8058bafa044d085fa2086.png"
              alt="AIRPURE Logo"
              className="h-12 w-auto"
            />
          </a>

          <div className="hidden lg:flex items-center gap-8">
            <a href="/" className="text-sm font-medium text-slate-600 hover:text-orange-500 transition-colors cursor-pointer">Accueil</a>
            <a href="/#solutions" className="text-sm font-medium text-slate-600 hover:text-orange-500 transition-colors cursor-pointer">Nos Solutions</a>
            <a href="/#aides" className="text-sm font-medium text-slate-600 hover:text-orange-500 transition-colors cursor-pointer">Aides de l'État</a>
            <a href="/contrat-entretien" className="text-sm font-bold text-orange-500 cursor-pointer">Contrats d'entretien</a>
            <a href="/#contact" className="text-sm font-medium text-slate-600 hover:text-orange-500 transition-colors cursor-pointer">Contact</a>
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <div className="text-right">
              <p className="text-xs text-slate-500">Appel gratuit</p>
              <p className="text-base font-bold text-slate-800">01 89 29 33 23</p>
            </div>
            <a href="tel:0189293323" className="w-10 h-10 bg-orange-500 hover:bg-orange-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
              <i className="ri-phone-line text-white text-lg"></i>
            </a>
            <a href="/#contact" className="bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors cursor-pointer whitespace-nowrap">
              Devis gratuit
            </a>
          </div>

          <button className="lg:hidden p-2" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <i className={`text-2xl text-slate-800 ${isMenuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="lg:hidden bg-white border-t border-slate-100 py-4 rounded-b-2xl shadow-xl">
            <a href="/" className="block px-6 py-3 text-slate-700 hover:text-orange-500 font-medium cursor-pointer">Accueil</a>
            <a href="/#solutions" className="block px-6 py-3 text-slate-700 hover:text-orange-500 font-medium cursor-pointer">Nos Solutions</a>
            <a href="/#aides" className="block px-6 py-3 text-slate-700 hover:text-orange-500 font-medium cursor-pointer">Aides de l'État</a>
            <a href="/contrat-entretien" className="block px-6 py-3 text-orange-500 font-bold cursor-pointer">Contrats d'entretien</a>
            <a href="/#contact" className="block px-6 py-3 text-slate-700 hover:text-orange-500 font-medium cursor-pointer">Contact</a>
            <div className="px-6 pt-4">
              <a href="tel:0189293323" className="flex items-center gap-3 bg-orange-500 text-white px-5 py-3 rounded-full font-semibold justify-center cursor-pointer">
                <i className="ri-phone-line"></i> 01 89 29 33 23
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
